import Alert from "@mui/material/Alert";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import React from "react";
import { fetchJson, API_BASE } from "../utils";
import AlbumQuantity from "../components/AlbumQuantity";
function ArtistPageContent({ artistId, onSelectAlbum }) {
  const [artist, setArtist] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [includeFeatured, setIncludeFeatured] = React.useState(false);
  const [retry, setRetry] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const controller = new AbortController();
    setError(null);
    setLoading(true);
    fetchJson(
      `${API_BASE}/artists/${artistId}/?include_featured=${includeFeatured}`,
      {
        credentials: "include",
        signal: controller.signal,
      },
    )
      .then((data) => {
        if (!controller.signal.aborted) setArtist(data);
      })
      .catch((failure) => {
        if (!controller.signal.aborted) setError(failure);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [artistId, includeFeatured, retry]);
  if (error) {
    return (
      <Alert role="alert" severity="error">
        Error loading artist: {error.message}
        <Button className="btn" onClick={() => setRetry((value) => value + 1)}>
          Retry
        </Button>
      </Alert>
    );
  }
  if (!artist) {
    return <div role="status">Loading...</div>;
  }
  return (
    <div>
      <div className="artist-details">
        <img
          className="artist-image"
          src={`${API_BASE}/artists/${artistId}/image/`}
          alt={`${artist.name}`}
          loading="lazy"
        />
        <h2>{artist.name}</h2>
      </div>

      <label>
        <Checkbox
          checked={includeFeatured}
          onChange={(e) => setIncludeFeatured(e.target.checked)}
        />
        Include featured albums
      </label>
      {loading && <p role="status">Loading albums…</p>}

      {artist.albums && artist.albums.length > 0 ? (
        <ul className="album-grid">
          {artist.albums.map((album, index) => (
            <li
              key={album.id}
              className="album-tile"
              style={{
                "--order": index,
              }}
              onClick={() => onSelectAlbum(album.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelectAlbum(album.id);
                }
              }}
            >
              <div className="album-thumb">
                <img
                  src={`${API_BASE}/albums/${album.id}/image/`}
                  alt={`${album.title} cover`}
                  loading="lazy"
                />
              </div>
              <div className="album-info">
                <div className="album-title">{album.title}</div>
                <AlbumQuantity quantity={album.quantity} />
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>No albums found.</p>
      )}
    </div>
  );
}
export default function ArtistPage(props) {
  return <ArtistPageContent key={props.artistId} {...props} />;
}
